import { PARAMETER_LANGUAGE } from "src/Utilities/constants";
import {getUserLanguageFromBrowser} from "src/Utilities/language";

const useLanguageMiddleware = (req, action, next) => {
  let queryParams = new URLSearchParams(window.location.search);
  const locale = getUserLanguageFromBrowser();
  const sessionLanguage = sessionStorage.getItem("userLanguage");
  const localLanguage = localStorage.getItem("userLanguage");

let headers;
  function addHeaders() {
    headers = req.init.headers;
    headers.append("accept-language", locale ? locale : "en");
  }
  addHeaders();
  next();
};

export default useLanguageMiddleware;
